<app-header-modal-layout
  [headerTitle]="'Delete Simulation'"
  [headerColor]="'#900000'"
  [footerSubmitText]="'Delete'"
  [footerCancelText]="'Cancel'"
  [footerSubmitColor]="'#900000'"
  [modalSize]="'XL'"
  [footerSubmitDisabled]="(selectedSimulation$ | async) == null"
  (close)="onClose()"
  (submit)="handleDeleteSimulation($event)"
>
  <app-delete-simulation-filter
    [customers]="customers"
    [regions]="regions"
    [projects]="projects"
    [simulations]="simulations"
    (filterChange)="onFilterChange($event)"
  ></app-delete-simulation-filter>
  <app-delete-simulation-table
  ></app-delete-simulation-table>
</app-header-modal-layout>
